import React from "react";

export default class InstagramQuery extends React.Component {
  constructor() {
    super();
    this.state = { imageURLs: [] };
  }

  componentDidMount() {
    window.fbLoaded.promise.then(() => {
      FB.api(
        "/" + process.env.INSTAGRAM_ID,
        "get",
        {
          fields: "media.limit(10){media_url}",
          access_token: process.env.ACCESS_TOKEN
        },
        resp => {
          let res = [];
          resp.media.data.forEach(e => res.push(e.media_url));
          this.setState({ imageURLs: res });
        }
      );
    });
  }

  render() {
    return this.props.children(this.state.imageURLs);
  }
}



// WEBPACK FOOTER //
// ./src/components/InstagramQuery/InstagramQuery.jsx